<template>
    <div
        :class="[
            cookie.position === 'bottom' ? 'bottom-0 transition-banner-bottom' : '',
            cookie.position === 'top' ? 'top-0 transition-banner-top' : '',
            nonFixed ? 'absolute' : 'fixed',
        ]"
        class="inset-x-0 font-normal"
    >
        <div :style="{ 'background-color': cookie.backColor }">
            <div class="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
                <div class="flex items-center justify-between flex-wrap">
                    <div class="flex-1 flex-shrink-0 flex items-center w-full sm:w-auto">
                        <p
                            :style="{ color: cookie.textColor, 'font-family': cookie.fontFamily }"
                            class="text-sm"
                        >
                            <cUtilsEdit
                                class="inline"
                                @edit="goToContentCookieField('cookieTitle')"
                            >
                                <span class="font-semibold"> {{ cookie.title }} {{}} </span>
                            </cUtilsEdit>
                            <br class="inline sm:hidden" />
                            <cUtilsEdit class="inline" @edit="goToContentCookieField('cookieDesc')">
                                <span class="opacity-80"> {{ cookie.desc }} {{}} </span>
                            </cUtilsEdit>
                            <a
                                class="opacity-80 underline"
                                v-if="cookie.policyLink"
                                :href="cookie.policyUrl"
                                @click.prevent="goToLink(cookie.policyUrl)"
                            >
                                <cUtilsEdit
                                    class="inline"
                                    @edit="goToContentCookieField('cookiePolicyText')"
                                >
                                    <span>{{ cookie.policyText }}</span>
                                </cUtilsEdit>
                            </a>
                        </p>
                    </div>
                    <div class="order-1 mt-4 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
                        <button
                            data-ec-accept
                            @click="handleActionClick"
                            :style="{
                                'background-color': cookie.buttonColor,
                                color: cookie.backColor,
                                'font-family': cookie.fontFamily,
                            }"
                            class="cursor-pointer flex items-center justify-center px-3.5 py-2.5 border border-transparent rounded-lg shadow-sm text-sm font-medium hover:opacity-80 w-full"
                        >
                            <cUtilsEdit @edit="goToContentCookieField('cookieAcceptText')">
                                <span>{{ cookie.acceptText }}</span>
                            </cUtilsEdit>
                        </button>
                    </div>
                    <div
                        v-if="cookie.cancelText"
                        class="order-2 flex-shrink-0 w-full sm:order-1 mt-2 sm:mr-3 sm:mt-0 sm:w-auto"
                    >
                        <button
                            @click="$emit('showAdjust')"
                            data-ec-adjust
                            :style="{
                                'border-color': cookie.buttonColor,
                                color: cookie.buttonColor,
                                'font-family': cookie.fontFamily,
                            }"
                            class="cursor-pointer flex items-center justify-center px-3.5 py-2.5 border rounded-lg shadow-sm text-sm font-medium hover:opacity-50 w-full"
                        >
                            <cUtilsEdit @edit="goToContentCookieField('cookieCancelText')">
                                <span>{{ cookie.cancelText }}</span>
                            </cUtilsEdit>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { handleActionClick } from "@/shared/utils";
import { useGoToLink } from "@/shared/utils/router/useGoToLink";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { useCookieGoTo } from "@/views/tools/cookie/utils/useCookieGoTo";

export default {
    name: "vBanner",
    props: {
        cookie: Object,
        nonFixed: Boolean,
    },
    components: {
        cUtilsEdit,
    },
    setup() {
        const { goToLink } = useGoToLink();
        const { goToContentCookieField } = useCookieGoTo();
        return {
            goToLink,
            goToContentCookieField,
        };
    },
    emits: ["showAdjust"],
    methods: {
        handleActionClick,
    },
};
</script>
